<template>
		<div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="80" src="../../static/images/back2.png" />
        </div>
        <div class="nav-t"><span>{{$t('books')}}</span></div>
      </div>
    </div>
			<div class="home-content crfff" ref="scrollContainer" @scroll="handleScroll">
        <div class="book">
          <div class="book-list">
            <div class="book-item" v-for="item in book" :key="item.id" @click="goBook(item.id)">
              <img :src="item.image" class="book-img" />
              <div class="book-name">{{ item.name }}</div>
            </div>
          </div>
          <!-- 加载更多提示 -->
          <div class="load-more-tip" v-if="loading">
            <div class="loading-text">{{$t('loading') || 'loading...'}}</div>
          </div>
          <div class="load-more-tip" v-if="!hasMore && book.length > 0">
            <div class="load-end-text">{{$t('loadMore2') || 'no more books'}}</div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
        book:[],
        page: 1, // 当前页码
        limit: 10, // 每页数量
        hasMore: true, // 是否还有更多数据
        loading: false, // 是否正在加载
        total: 0 // 总数据量
      }
    },
	created(){
    this.get_book();
	},
  methods: {
		back(){
      this.$router.go(-1);
		},

    get_book(isLoadMore = false) {
      let that = this;

      // 如果正在加载或没有更多数据，则不请求
      if (that.loading || (!isLoadMore && !that.hasMore)) {
        return;
      }

      that.loading = true;

      // 首次加载显示loading，加载更多不显示
      if (!isLoadMore) {
        that.$parent.loadModal(true);
      }

      that.$api.post('/api/book/list', {
        page: that.page,
        limit: that.limit
      }, r => {
        that.$parent.returnCode(r, function(){
          that.$parent.loadModal(false);

          if (isLoadMore) {
            // 加载更多：追加数据
            that.book = that.book.concat(r.data.list || []);
          } else {
            // 首次加载：替换数据
            that.book = r.data.list || [];
          }

          // 更新分页信息
          that.total = r.data.total || 0;
          that.hasMore = r.data.has_more !== false;

          that.loading = false;
        });
      }, () => {
        // 请求失败
        that.loading = false;
        that.$parent.loadModal(false);
      });
    },

    // 滚动事件处理
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      // 计算是否滚动到底部（距离底部50px时触发）
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      if (scrollHeight - scrollTop - clientHeight < 50) {
        // 滚动到底部，加载更多
        if (this.hasMore && !this.loading) {
          this.page++;
          this.get_book(true);
        }
      }
    },

    goBook(id) {
      this.$router.push({ path: '/BookDetail?id=' + id })
    },
	}
}
</script>
<style>
/* book样式 */
.book {
  padding: 16px; /* 页面整体左右留白 */
}

.book-list {
  display: grid;
  grid-template-columns: repeat(3, 5fr); /* 两列 */
  gap: 20px; /* 行列间距 */
  margin-top: 20px;
}

.book-item {
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.book-item:hover {
  transform: scale(1.05);
}

.book-img {
  width: 100%;
  border-radius: 30px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
      border: 2px solid #130000;
}

.book-name {
  margin-top: 8px;
  font-size: 23px;
  font-weight: bold;
  color: #865a30;
}

.home-content {
  height: calc(100vh - 200px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.load-more-tip {
  text-align: center;
  padding: 20px 0;
}

.loading-text, .load-end-text {
  font-size: 24px;
  color: #865a30;
}

</style>



// WEBPACK FOOTER //
// src/page/Book.vue